import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-center" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_InventoryEditWizard = _resolveComponent("InventoryEditWizard")!
  const _component_StockAssessment = _resolveComponent("StockAssessment")!
  const _component_SalesMargin = _resolveComponent("SalesMargin")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_StockOperationEdition = _resolveComponent("StockOperationEdition")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_CreateInvoiceProduct = _resolveComponent("CreateInvoiceProduct")!
  const _component_InvoiceProductImport = _resolveComponent("InvoiceProductImport")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
              id: "Devis",
              class: "bg-white",
              style: {"border-radius":"16px","overflow":"hidden"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "Operation",
                  href: "#Operation",
                  "data-cy": "stocks-operation-tab"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Opérations")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "Stock",
                  href: "#Stock",
                  "data-cy": "stocks-stock-tab"
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("Stock")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "Inventary",
                  href: "#Inventary",
                  "data-cy": "stocks-inventary-tab"
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("Inventaire")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "Product",
                  href: "#Product",
                  "data-cy": "stocks-product-tab",
                  id: "Product"
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode("Produits")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "StockAssessment",
                  href: "#StockAssessment",
                  "data-cy": "stocks-operation-tab"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode("Centres d'analyse")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "SalesMargin",
                  href: "#SalesMargin",
                  "data-cy": "stocks-sales-margin-tab",
                  id: "SalesMargin"
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("Marges sur ventes")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.activeTab) = $event)),
              style: {"background-color":"transparent !important"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs_window_item, {
                  key: "Operation",
                  value: "Operation"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "my-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "pr-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_primary, {
                                  block: "",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openOperationDialog('INPUT'))),
                                  "data-cy": "stocks-new-input-operation"
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createTextVNode(" Ajouter ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_primary, {
                                  block: "",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openOperationDialog('OUTPUT'))),
                                  "data-cy": "stocks-new-output-operation"
                                }, {
                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createTextVNode(" Retirer ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_primary, {
                                  block: "",
                                  onClick: _ctx.computeStockOperation,
                                  "data-cy": "stocks-compute-operation",
                                  loading: _ctx.computeStockOperationLoading
                                }, {
                                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                                    _createTextVNode(" Calculer ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick", "loading"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "pl-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.search,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                                  "append-inner-icon": "$fa-search",
                                  clearable: "",
                                  "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (_ctx.search = '')),
                                  label: "Recherche",
                                  regular: "",
                                  outlined: "",
                                  "hide-details": "",
                                  autofocus: "",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_data_table_server, {
                      headers: _ctx.operationHeaders,
                      items: _ctx.stockOperations,
                      page: _ctx.operationPagination.page,
                      "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.operationPagination.page) = $event)),
                      "items-per-page": _ctx.operationPagination.rowsPerPage,
                      "onUpdate:itemsPerPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.operationPagination.rowsPerPage) = $event)),
                      "items-length": _ctx.operationPagination.totalItems,
                      "onUpdate:itemsLength": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.operationPagination.totalItems) = $event)),
                      "items-per-page-options": _ctx.itemsPerPageOptions,
                      "sort-by": _ctx.operationPagination.sortBy,
                      "onUpdate:sortBy": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.operationPagination.sortBy) = $event)),
                      loading: _ctx.stockLoading,
                      class: "table",
                      "fixed-header": "",
                      "max-height": "60vh",
                      "multi-sort": false
                    }, {
                      item: _withCtx(({ item }) => [
                        _createElementVNode("tr", {
                          onClick: ($event: any) => (_ctx.editOperation(item)),
                          style: {"cursor":"pointer"}
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.title || "-"), 1),
                          _createElementVNode("td", _hoisted_2, [
                            (item.tagName)
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 0,
                                  label: "",
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.tagName), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getOperationType(item.productQuantity)), 1),
                          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formatDate(item.date)), 1),
                          _createElementVNode("td", _hoisted_5, [
                            (item.stockProduct)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getProductQuantityText(
                                            item.stockProduct,
                                            item.productQuantity,
                                        )), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_7, _toDisplayString(item.quantity ? Math.abs(item.quantity) : ""), 1),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(item.productQuantity > 0
                                            ? _ctx.newCommonFormatCurrency(item.price, undefined)
                                            : ""), 1),
                          _createElementVNode("td", _hoisted_9, _toDisplayString(item.productQuantity > 0
                                            ? _ctx.newCommonFormatCurrency(item.unitPrice, undefined)
                                            : ""), 1),
                          _createElementVNode("td", {
                            class: "text-center",
                            onClick: _withModifiers(($event: any) => (_ctx.openDocument(item)), ["stop"])
                          }, [
                            (!!_ctx.getDocumentId(item))
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  icon: "$oss-file",
                                  color: "blue",
                                  size: "small"
                                }))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_10)
                        ], 8, _hoisted_1),
                        (item.children && item.children.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children, (child, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: item.id + '-' + index
                              }, [
                                _createElementVNode("tr", {
                                  onClick: ($event: any) => (_ctx.editOperation(child)),
                                  style: {"cursor":"pointer"}
                                }, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_icon, {
                                      icon: "$subdirectory_arrow_right",
                                      style: {"margin-left":"8px","margin-right":"8px"}
                                    }),
                                    _createTextVNode(" " + _toDisplayString(child.title || "-"), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_12, [
                                    (child.tagName)
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 0,
                                          label: "",
                                          size: "x-small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(child.tagName), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.getOperationType(child.quantity)), 1),
                                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatDate(child.date)), 1),
                                  _createElementVNode("td", _hoisted_15, _toDisplayString(child.productQuantityDisplay), 1),
                                  _createElementVNode("td", _hoisted_16, _toDisplayString(child.quantity ? Math.abs(child.quantity) : ""), 1),
                                  _createElementVNode("td", _hoisted_17, _toDisplayString(child.quantity > 0
                                                    ? _ctx.newCommonFormatCurrency(
                                                          child.price,
                                                          undefined,
                                                      )
                                                    : ""), 1),
                                  _createElementVNode("td", _hoisted_18, _toDisplayString(child.quantity > 0
                                                    ? _ctx.newCommonFormatCurrency(
                                                          child.unitPrice,
                                                          undefined,
                                                      )
                                                    : ""), 1),
                                  _cache[32] || (_cache[32] = _createElementVNode("td", { class: "text-center" }, null, -1))
                                ], 8, _hoisted_11),
                                (child.children && child.children.length)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(child.children, (childChild, index2) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: item.id + '-' + index + '-' + index2,
                                        onClick: ($event: any) => (_ctx.editOperation(childChild)),
                                        style: {"cursor":"pointer"}
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_v_icon, {
                                            icon: "$subdirectory_arrow_right",
                                            style: {"margin-left":"16px","margin-right":"8px"}
                                          }),
                                          _createTextVNode(" " + _toDisplayString(childChild.title || "-"), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_20, [
                                          (childChild.tagName)
                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                key: 0,
                                                label: "",
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(childChild.tagName), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.getOperationType(childChild.quantity)), 1),
                                        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatDate(childChild.date)), 1),
                                        _createElementVNode("td", _hoisted_23, _toDisplayString(childChild.productQuantityDisplay), 1),
                                        _createElementVNode("td", _hoisted_24, _toDisplayString(childChild.quantity
                                                        ? Math.abs(childChild.quantity)
                                                        : ""), 1),
                                        _createElementVNode("td", _hoisted_25, _toDisplayString(childChild.quantity > 0
                                                        ? _ctx.newCommonFormatCurrency(
                                                              childChild.price,
                                                              undefined,
                                                          )
                                                        : ""), 1),
                                        _createElementVNode("td", _hoisted_26, _toDisplayString(childChild.quantity > 0
                                                        ? _ctx.newCommonFormatCurrency(
                                                              childChild.unitPrice,
                                                              undefined,
                                                          )
                                                        : ""), 1),
                                        _cache[33] || (_cache[33] = _createElementVNode("td", { class: "text-center" }, null, -1))
                                      ], 8, _hoisted_19))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "page", "items-per-page", "items-length", "items-per-page-options", "sort-by", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  key: "Stock",
                  value: "Stock"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "my-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              class: "pl-4",
                              modelValue: _ctx.isFIFO,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isFIFO) = $event)),
                              label: "FIFO",
                              "hide-details": "",
                              inset: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_data_table, {
                      headers: _ctx.stockHeaders,
                      items: _ctx.stockItems,
                      loading: _ctx.stockLoading,
                      class: "table",
                      "fixed-header": "",
                      "max-height": "60vh",
                      "multi-sort": false
                    }, {
                      item: _withCtx(({ item }) => [
                        _createElementVNode("tr", {
                          class: _normalizeClass(item.available > 0 ? '' : 'error')
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.title || "-"), 1),
                          _createElementVNode("td", null, _toDisplayString(item.reference || "-"), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.mathFix(item.acquired, 3) || "0"), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.newCommonFormatCurrency(item.acquiredPrice, undefined)), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.mathFix(item.consumed, 3) || "0"), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.newCommonFormatCurrency(item.consumedPrice, undefined)), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.newCommonFormatCurrency(item.consumedUnitPrice, undefined)), 1),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.mathFix(item.available, 3) || "0"), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.newCommonFormatCurrency(item.residualPrice, undefined)), 1)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  key: "Inventary",
                  value: "Inventary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InventoryEditWizard, {
                      step: 0,
                      ref: "invoiceEditWizard"
                    }, null, 512)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  key: "Product",
                  value: "Product"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "my-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "px-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_primary, {
                                  block: "",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => {
                                    _ctx.productDialog = true;
                                    _ctx.productId = '';
                                }),
                                  "data-cy": "stocks-new-product"
                                }, {
                                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                                    _createTextVNode(" Nouveau produit ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "px-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_primary, {
                                  block: "",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.importProductsDialog = true)),
                                  "data-cy": "stocks-new-product"
                                }, {
                                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                                    _createTextVNode(" Importer produits ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_data_table_server, {
                      headers: _ctx.productHeaders,
                      items: _ctx.products,
                      page: _ctx.productPagination.page,
                      "onUpdate:page": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.productPagination.page) = $event)),
                      "items-per-page": _ctx.productPagination.rowsPerPage,
                      "onUpdate:itemsPerPage": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.productPagination.rowsPerPage) = $event)),
                      "items-length": _ctx.productPagination.totalItems,
                      "onUpdate:itemsLength": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.productPagination.totalItems) = $event)),
                      "items-per-page-options": _ctx.itemsPerPageOptions,
                      "sort-by": _ctx.productPagination.sortBy,
                      "onUpdate:sortBy": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.productPagination.sortBy) = $event)),
                      loading: _ctx.productLoading,
                      class: "table",
                      "fixed-header": "",
                      "max-height": "60vh",
                      "multi-sort": false
                    }, {
                      item: _withCtx(({ item }) => [
                        _createElementVNode("tr", {
                          "data-cy": "stocks-product",
                          onClick: ($event: any) => (_ctx.editProduct(item))
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.reference), 1),
                          _createElementVNode("td", null, [
                            (item.tag)
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 0,
                                  label: "",
                                  size: "x-small",
                                  ripple: false
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.tag.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.title), 1)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getType(item.type)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.newCommonFormatCurrency(item.unitPrice, undefined)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getSymbolData(item).text), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_v_switch, {
                              modelValue: item.outDated,
                              "onUpdate:modelValue": ($event: any) => ((item.outDated) = $event),
                              inset: "",
                              color: "primary",
                              density: "compact",
                              "hide-details": "",
                              onClick: _withModifiers(($event: any) => (_ctx.setOutDatedProduct(item)), ["stop"])
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                          ])
                        ], 8, _hoisted_34)
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "page", "items-per-page", "items-length", "items-per-page-options", "sort-by", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  key: "StockAssessment",
                  value: "StockAssessment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_StockAssessment, {
                      companyId: _ctx.selectedCompany.id
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  key: "SalesMargin",
                  value: "SalesMargin"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SalesMargin, {
                      companyId: _ctx.selectedCompany.id
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.operationDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            persistent: "",
            modelValue: _ctx.operationDialog,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.operationDialog) = $event)),
            fullscreen: _ctx.$vuetify.display.mobile,
            title: _ctx.operationTitle,
            actions: _ctx.actions,
            width: "55vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_StockOperationEdition, {
                id: _ctx.stockOperationId,
                type: _ctx.operationType,
                companyId: _ctx.companyId,
                actions: _ctx.actions,
                onOperationSaved: _ctx.onOperationSaved
              }, null, 8, ["id", "type", "companyId", "actions", "onOperationSaved"])
            ]),
            _: 1
          }, 8, ["modelValue", "fullscreen", "title", "actions"]))
        : _createCommentVNode("", true),
      (_ctx.inventoryDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            persistent: "",
            modelValue: _ctx.inventoryDialog,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inventoryDialog) = $event)),
            "max-width": !_ctx.$vuetify.display.mobile ? '900px' : undefined,
            fullscreen: _ctx.$vuetify.display.mobile,
            title: "Création d'un Inventaire",
            actions: _ctx.actions
          }, null, 8, ["modelValue", "max-width", "fullscreen", "actions"]))
        : _createCommentVNode("", true),
      (_ctx.productDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 3,
            persistent: "",
            modelValue: _ctx.productDialog,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.productDialog) = $event)),
            "max-width": !_ctx.$vuetify.display.mobile ? '1050px' : undefined,
            fullscreen: _ctx.$vuetify.display.mobile,
            "hide-overlay": _ctx.$vuetify.display.mobile,
            title: _ctx.productId ? 'Modification d\'un produit' : 'Création d\'un produit',
            actions: _ctx.productActions
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CreateInvoiceProduct, {
                id: _ctx.productId,
                companyId: _ctx.companyId,
                actions: _ctx.productActions,
                stock: true,
                onProductSaved: _ctx.onProductSaved
              }, null, 8, ["id", "companyId", "actions", "onProductSaved"])
            ]),
            _: 1
          }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "title", "actions"]))
        : _createCommentVNode("", true),
      (_ctx.importProductsDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 4,
            modelValue: _ctx.importProductsDialog,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.importProductsDialog) = $event)),
            minWidth: _ctx.width,
            title: "Importez vos produits",
            actions: _ctx.importActions
          }, {
            default: _withCtx(() => [
              (_ctx.importProductsDialog)
                ? (_openBlock(), _createBlock(_component_InvoiceProductImport, {
                    key: 0,
                    ref: "importComponent",
                    documentType: 'STOCK_PRODUCTS',
                    actions: _ctx.importActions,
                    selectedCompanyId: _ctx.selectedCompany.id,
                    onDocumentImported: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onDocumentImported())),
                    onWidth: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changeWidth()))
                  }, null, 8, ["actions", "selectedCompanyId"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "minWidth", "actions"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}